export const getUserLoading = (state) => state.userAuthReducer.userLoading;
export const getUser = (state) => state.userAuthReducer.user;
export const getEmail = (state) => state.userAuthReducer.user.email;
export const getProvider = (state) => state.userAuthReducer.user.provider;
export const getAuthError = (state) => state.userAuthReducer.error;
export const getCookiePref = (state) => state.userAuthReducer.cookiePref;
export const getMemberships = (state) =>
  state.userAuthReducer.memberships ?? state.userAuthReducer.user?.memberships ?? [];

// CE visibility is controlled by the organization's ce_enabled flag
export const canViewContinuingEducation = (user) =>
  user.role === 'know-admin' ||
  (user.ce_enabled && user.role !== 'allied' && user.role !== 'student');
